/**
 * Copyright © 2019 2020 2021 7thCode.(http://seventh-code.com/)
 * This software is released under the MIT License.
 * opensource.org/licenses/mit-license.php
 */

"use strict";

import {Directive, EventEmitter, HostListener, Input, Output} from "@angular/core";
import {MatDialog, MatDialogRef} from "@angular/material/dialog";

import {Callback, IContent, IErrorObject} from "../../../../../types/platform/universe";
import {IInquiryModelContent} from "../../../../../types/aig/universe";
import {SessionService} from "../../../platform/base/services/session.service";
import {Overlay} from "@angular/cdk/overlay";
import {InquiriesService} from "../../inquiry/inquiries.service";
import {BreakpointObserver} from "@angular/cdk/layout";

import {ContactInfoDialogComponent} from "../contact-info-dialog/contact-info-dialog.component";
import {ContactDialogComponent} from "./contact-dialog.component";

@Directive({
	selector: "[contact-button]",
})

/**
 * todo
 */
export class ContactDialogDirective {
	public breakpoint: number = 320;

	@Input() public username = "";
	@Output() public complete = new EventEmitter<any>();

	/**
	 * todo
	 */
	constructor(
		protected session: SessionService,
		protected overlay: Overlay,
		protected matDialog: MatDialog,
		protected inquiriesService: InquiriesService,
		protected breakpointObserver: BreakpointObserver,
	) {
	}

	/**
	 * 作成
	 * @params data 初期データ
	 * @params callback コールバック
	 * @returns none なし
	 */
	public create(content: IContent, callback: Callback<any>): void {
		this.inquiriesService.post(content, (error: IErrorObject, result: any): void => {
			if (!error) {
				callback(null, result);
			} else {
				callback(error, null);
			}
		});
	}

	/**
	 * todo
	 */
	private Complete(type: string, value: any): void {
		this.complete.emit({type, value});
	}

	/**
	 * クリエイトダイアログ
	 */
	@HostListener("click", ["$event.target"])
	public onClick(): void {

		let dialogMinWidth = "320px";
		let dialogMaxWidth = "740px";
		let dialogHeight = "fit-content";

		const initalData: IInquiryModelContent = {
			id: null,
			username: this.username,
			title: "お問い合わせ",
			contentname: "お問い合わせ内容",
			contentdescription:"",
			category: "contact",
			status: 0,
			question: "",
			answer: "",
			hascancel:true
		};

		this.breakpoint = this.widthToColumns(window.innerWidth);
		if (this.breakpoint == 100) {
			dialogMinWidth = "100vw";
			dialogMaxWidth = "100vw";
			dialogHeight = "100vh";
		}

		const dialog: MatDialogRef<any> = this.matDialog.open(ContactDialogComponent, {
			width: "95vw",
			// minWidth: "320px",
			// maxWidth: "740px",
			// height: "fit-content",
			minWidth: dialogMinWidth, //width: 100vw;
			maxWidth: dialogMaxWidth, // height: 100vw;
			height: dialogHeight, // height: 100vh;
			panelClass: "dark-card",
			data: {content: initalData},
			disableClose: true,
		});

		dialog.beforeClosed().subscribe((result: any): void => {
			if (result) { // if not cancel then
				this.create(result, (error: IErrorObject, result: any): void => {
					if (!error) {

						const resultDialogContent: any = {title: "お問い合わせ", message: "お問い合わせ承りました。"};

						const info_dialog: MatDialogRef<any> = this.matDialog.open(ContactInfoDialogComponent, {
							width: "30%",
							minWidth: "320px",
							height: "fit-content",
							data: {content: resultDialogContent},
							disableClose: true,
						});

						info_dialog.afterClosed().subscribe((result: any): void => {
						});

					} else {
						this.Complete("error", null);
					}
				});
			} else {
				this.Complete("error", null);
			}
		});

		dialog.afterClosed().subscribe((result: any): void => {
			if (result) {
				this.Complete("", result);
			}
		});

	}

	/**
	 *
	 * @param width
	 */
	private widthToColumns(width: number): number {
		let result: number;
		result = width / 320;
		return result;
	}
}
